module.exports = __webpack_public_path__ + "static/media/bt_top_daytraining_normal.cc81f2c7.png";